export enum EditMode {
    MODE_DETAIL,
    MODE_ADD,
    MODE_REMOVE,
}
